module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-forward-513a65c763ff51862dd4d908690b06a2.png";